/**
 * UranIA PA — Segmento layout (pubblico).
 *
 * Pathless (`id: '_pubblico'`, nessun `path`): non aggiunge un segmento
 * all'URL, porta la guardia comune a tutte le rotte pre-login. Chi è già
 * autenticato viene rimandato all'atterraggio del proprio ruolo — stessa
 * logica che prima viveva solo in `index.tsx` (`smistaRadice`), ora
 * consolidata qui così vale per l'intero segmento (`/`, `/overview`,
 * `/scegli-accesso`, `/login`, `/login/pa`, `/login/beneficiari`), non
 * solo per la radice.
 *
 * Vedi "UranIA PA — Riordino della mappa delle rotte" §3/§5 (2026-09-07),
 * Rilascio A passo A.1.
 */

import { createRoute, Outlet } from '@tanstack/react-router';

import { ruoloCorrente } from '../lib/auth/ruolo-corrente.ts';
import { guardiaPubblico } from '../lib/ruoli.ts';
import { Route as RootRoute } from './__root.tsx';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  id: '_pubblico',
  beforeLoad: () => guardiaPubblico(ruoloCorrente()),
  component: Outlet,
});
